import { render, staticRenderFns } from "./ItemFooter.vue?vue&type=template&id=7682e5b2&scoped=true"
import script from "./ItemFooter.vue?vue&type=script&lang=js"
export * from "./ItemFooter.vue?vue&type=script&lang=js"
import style0 from "./ItemFooter.vue?vue&type=style&index=0&id=7682e5b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7682e5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7682e5b2')) {
      api.createRecord('7682e5b2', component.options)
    } else {
      api.reload('7682e5b2', component.options)
    }
    module.hot.accept("./ItemFooter.vue?vue&type=template&id=7682e5b2&scoped=true", function () {
      api.rerender('7682e5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/modelcomparison/assets/frontend/components/ItemFooter.vue"
export default component.exports